/** @jsxImportSource theme-ui @jsxRuntime classic */
import { H } from '@hzdg/sectioning';
import {
  AnchorSection,
  Box,
  Button,
  getThemeByName,
  Modal,
  SanityRichText,
  Section,
  ThemeProvider,
  Sticky,
} from '@tishman/components';
import React, { useState } from 'react';

import { TicketComparisonModal } from '../../TicketComparisonModal';
import { THEME_ORDER } from '../common/themeOrder';

import { CategoryChooser } from './CategoryChooser';
import { MobileTicketCard } from './MobileTicketCard';

import type { BuyTicketsProps } from '../types';

export function BuyTicketsMobile({
  categories,
}: BuyTicketsProps): React.JSX.Element {
  const [comparisonModalCategoryId, setComparisonModalCategoryId] = useState<
    string | null
  >(null);

  return (
    <Section
      data-mobile="true"
      data-section="BuyTicketsMobile"
      sx={{
        display: ['block', 'none'],
        width: '100%',
        maxWidth: '100%',
      }}
    >
      <Sticky data-section="BuyTicketsMobile" top="-2">
        <Section sx={{ px: [3, 4] }}>
          <CategoryChooser categories={categories} />
        </Section>
      </Sticky>

      {categories.map((category, i) => (
        <AnchorSection
          id={`${category.slug?.current}`}
          key={category.id}
          sx={{
            pt: i > 0 ? '56px' : '0px',
            pb: '36px',
            px: [3, 4],
            width: '100%',
            maxWidth: '100%',
          }}
          theme={THEME_ORDER[i] || 'Rock Center Black'}
        >
          <H
            sx={{
              variant: 'styles.h2',
              mb: '12px',
              fontFamily: 'headingSecondary',
            }}
          >
            {category.title}
          </H>

          <Box
            sx={{
              p: {
                mb: '0px',
              },
            }}
          >
            <SanityRichText
              blocks={
                category.description && Array.isArray(category.description)
                  ? category.description
                  : []
              }
            />
          </Box>

          {!!category.availableFeatures?.length && (
            <Box
              sx={{
                mt: 3,
                width: '100%',
              }}
            >
              <Button
                onClick={() => {
                  setComparisonModalCategoryId(category.id);
                }}
                sx={{
                  height: '52px',
                  px: '0px',
                  py: '0px',
                  width: '100%',
                }}
              >
                Compare Tickets
              </Button>
              <ThemeProvider theme={getThemeByName('Rock Center')}>
                <Modal
                  id={`buy-tickets-mobile-ticket-comparison-modal-${category.id}`}
                  isOpen={comparisonModalCategoryId === category.id}
                  onClose={() => setComparisonModalCategoryId(null)}
                >
                  <TicketComparisonModal
                    category={category}
                    onClose={() => setComparisonModalCategoryId(null)}
                  />
                </Modal>
              </ThemeProvider>
            </Box>
          )}

          {category.tickets?.map((ticket) => (
            <MobileTicketCard
              category={category as Queries.SanityTicketCategory}
              key={ticket?.id}
              ticket={ticket as Queries.SanityTicket}
            />
          ))}
        </AnchorSection>
      ))}
    </Section>
  );
}
